import React from 'react';
import { Stack, Typography } from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DocumentFile } from '@peerless/data-access/strapi';
import { icons } from '@peerless/ui-assets/icons';

interface Props {
  file: DocumentFile;
}

export const Document: React.FC<Props> = ({ file }) => {
  return (
    <a
      href={file.url}
      download
      target="_blank"
      rel="noreferrer"
      style={{ textDecoration: 'none', color: 'black' }}
    >
      <DocumentDisplay file={file} />
    </a>
  );
};

export const DocumentDisplay: React.FC<Props> = ({ file }) => {
  const isDWG = file.ext?.toLowerCase().replace('.', '') === 'dwg';
  return (
    <Stack
      spacing={1}
      alignItems="center"
      sx={{
        '.fa-lg': { fontSize: '4rem', color: isDWG ? 'success.main' : 'primary.main' },
      }}
    >
      <FontAwesomeIcon icon={getIconFromExtension(file.ext)} size="lg" />
      <Typography textAlign={'center'}>{file.name}</Typography>
    </Stack>
  );
};

const getIconFromExtension = (ext: string | undefined): IconProp => {
  // Normalize file extension names by removing dots and lowercasing.
  switch (ext?.toLowerCase().replace('.', '')) {
    case 'pdf':
      return icons.filePdf;
    case 'dwg':
      return icons.fileCad;
    case 'configurator':
      return icons.fileVector;
    default:
      return icons.file;
  }
};
